import { http } from '../utils/http';

// 获取项目列表
export const reqFetchIsSupportWechat = () =>
  http.request({
    url: `/alert/judge/workwx`,
    method: 'GET',
    withUserId: 'PARAMS'
  });
